import { useEffect } from 'react';

import * as Sentry from '@sentry/react';
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

const sentryConfig: Sentry.BrowserOptions = {
  dsn: ENV.SENTRY_DSN,
  environment: ENV.ENVIRONMENT,
  release: ENV.SENTRY_RELEASE,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  sampleRate: ENV.SENTRY_SAMPLE_RATE,
  tracesSampleRate: ENV.SENTRY_TRACES_SAMPLE_RATE,
};

export const initializeSentry = (): ReturnType<(typeof Sentry)['init']> => {
  if (ENV.ENVIRONMENT === 'local') return;
  return Sentry.init(sentryConfig);
};

export const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);
